import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { PureComponent } from 'react';
import { ScoreIcon } from 'fable/ScoreIcon';
import style from './index.module.scss';
const defaultRatingStyle = 'emojis';
const getTextDir = (text) => {
    const elem = document.createElement('p');
    elem.setAttribute('hidden', 'true');
    elem.setAttribute('dir', 'auto');
    elem.innerText = text;
    document.body.append(elem);
    const dir = window.getComputedStyle(elem).direction;
    elem.remove();
    return dir;
};
export class ThankYouPreview extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            dir: 'ltr',
        };
    }
    componentDidMount() {
        this.setTextDir();
    }
    componentDidUpdate(prevProps) {
        const { placeholderText } = this.props;
        if (placeholderText !== prevProps.placeholderText) {
            this.setTextDir();
        }
    }
    setTextDir() {
        const { placeholderText } = this.props;
        if (placeholderText) {
            this.setState({
                dir: getTextDir(placeholderText),
            });
        }
    }
    render() {
        const { thankYouText, questionText, placeholderText, submitButtonText, ratingStyle = defaultRatingStyle, } = this.props;
        const { dir } = this.state;
        return (_jsx("div", Object.assign({ className: style.backdrop }, { children: _jsxs("section", Object.assign({ className: style.feedbackWrapper }, { children: [_jsx(ScoreIcon, { style: ratingStyle, score: 4, size: 40, showAll: true }), _jsx("div", Object.assign({ className: style.thankYouText, dir: "auto" }, { children: thankYouText })), _jsx("div", Object.assign({ className: style.question, dir: "auto" }, { children: questionText })), _jsx("textarea", { className: classnames(style.commentForm, style[dir]), placeholder: placeholderText, readOnly: true, dir: "auto" }), _jsx("input", { className: style.submitButton, value: submitButtonText, type: "button", dir: "auto" })] })) })));
    }
}
